export const KNOWLEDGE_BASES_ID_ENDPOINT = '/p/v4/kb/knowledge-bases/self';
export const KNOWLEDGE_BASE_CONFIG_ENDPOINT =
  '/p/v4/kb/knowledge-bases/:knowledgeBaseId?chat=true&lang=:lang';
